import { ca } from '@cian/analytics';

import { IAgentSchema, IOfferSchema } from 'shared/types/api-models/offer-card/v1/get-offer-data';

import { getCustomUrl } from '../../utils/tracking/getCustomUrl';

export function trackClickExport() {
  ca('event', {
    action: 'export_ads_tools',
    category: 'card',
    label: '',
    name: 'oldevent',
  });
}

export function trackClickDownloadPdf() {
  ca('event', {
    action: 'download_pdf_tools',
    category: 'card',
    label: '',
    name: 'oldevent',
  });
}

export function trackClickDownloadDocx() {
  ca('event', {
    action: 'download_docx_tools',
    category: 'card',
    label: '',
    name: 'oldevent',
  });
}

export function trackClickPrint() {
  ca('event', {
    action: 'print_open_tools',
    category: 'card',
    label: '',
    name: 'oldevent',
  });
}

export function trackClickComplaint(offer: IOfferSchema, agent: IAgentSchema | null) {
  ca('event', {
    action: 'complain_open_tools',
    category: 'card',
    label: getCustomUrl(offer, agent),
    name: 'oldevent',
  });
}

export function trackClickPrintButton() {
  ca('event', {
    action: 'print_open_tools',
    category: 'card',
    label: '',
    name: 'oldevent',
  });
}
